import { ref } from 'vue'

const selectedFilterSavings = ref('activities')

export { selectedFilterSavings }
